import { default as _91_46_46_46slug_93L0TrJgYySVMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/[...slug].vue?macro=true";
import { default as _404Qn7AiAbk2pMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/404.vue?macro=true";
import { default as index8M0kN4rn3FMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/arbochecklist/index.vue?macro=true";
import { default as bedankteKka1JF4LxMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/bedankt.vue?macro=true";
import { default as _91slug_9393AAwTiZrKMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/contact/[slug].vue?macro=true";
import { default as index5VpOBw96KvMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/contact/index.vue?macro=true";
import { default as indexbUELHKo462Meta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/index.vue?macro=true";
import { default as _91slug_93UCIsdatuHZMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/nieuws/[slug].vue?macro=true";
import { default as indexlaCiYwUx0LMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/nieuws/index.vue?macro=true";
import { default as open_45sollicitatieKyDHtRgB3HMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/open-sollicitatie.vue?macro=true";
import { default as _91_46_46_46slug_938GJlPg4EGWMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/over-westerduin/[...slug].vue?macro=true";
import { default as _91slug_93Oexp3HHQfvMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/referenties/[slug].vue?macro=true";
import { default as indextp0G2tltLmMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/referenties/index.vue?macro=true";
import { default as vacatures_45als_45_91slug_93yBG3cpX9QwMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures-als-[slug].vue?macro=true";
import { default as vacatures_45bij_45_91slug_93rhfhH23owUMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures-bij-[slug].vue?macro=true";
import { default as vacatures_45in_45_91slug_93NLehJPFQ57Meta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures-in-[slug].vue?macro=true";
import { default as _91slug_93aXCCm8Su3KMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures/[slug].vue?macro=true";
import { default as indexKoAgAB8awRMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures/index.vue?macro=true";
import { default as vragenI2Bd5lyTCdMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vragen.vue?macro=true";
import { default as _91_46_46_46slug_93HBL5YJ0b5eMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/[...slug].vue?macro=true";
import { default as bedanktkU4qgTQIVkMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/bedankt.vue?macro=true";
import { default as faqVNyXHC4VidMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/faq.vue?macro=true";
import { default as registratie_45inlenersbeloningmkvpjL23QgMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue?macro=true";
import { default as werkwijzeqOdfcX0bwhMeta } from "/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkwijze.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93L0TrJgYySVMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "404",
    path: "/404",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/404.vue").then(m => m.default || m)
  },
  {
    name: "arbochecklist",
    path: "/arbochecklist",
    meta: index8M0kN4rn3FMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/arbochecklist/index.vue").then(m => m.default || m)
  },
  {
    name: "bedankt",
    path: "/bedankt",
    meta: bedankteKka1JF4LxMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "contact-slug",
    path: "/contact/:slug()",
    meta: _91slug_9393AAwTiZrKMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/contact/[slug].vue").then(m => m.default || m)
  },
  {
    name: "contact",
    path: "/contact",
    meta: index5VpOBw96KvMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/contact/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    meta: indexbUELHKo462Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "nieuws-slug",
    path: "/nieuws/:slug()",
    meta: _91slug_93UCIsdatuHZMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/nieuws/[slug].vue").then(m => m.default || m)
  },
  {
    name: "nieuws",
    path: "/nieuws",
    meta: indexlaCiYwUx0LMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/nieuws/index.vue").then(m => m.default || m)
  },
  {
    name: "open-sollicitatie",
    path: "/open-sollicitatie",
    meta: open_45sollicitatieKyDHtRgB3HMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/open-sollicitatie.vue").then(m => m.default || m)
  },
  {
    name: "over-westerduin-slug",
    path: "/over-westerduin/:slug(.*)*",
    meta: _91_46_46_46slug_938GJlPg4EGWMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/over-westerduin/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties-slug",
    path: "/referenties/:slug()",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/referenties/[slug].vue").then(m => m.default || m)
  },
  {
    name: "referenties",
    path: "/referenties",
    meta: indextp0G2tltLmMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/referenties/index.vue").then(m => m.default || m)
  },
  {
    name: "vacatures-als-slug",
    path: "/vacatures-als-:slug()",
    meta: vacatures_45als_45_91slug_93yBG3cpX9QwMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures-als-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-bij-slug",
    path: "/vacatures-bij-:slug()",
    meta: vacatures_45bij_45_91slug_93rhfhH23owUMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures-bij-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-in-slug",
    path: "/vacatures-in-:slug()",
    meta: vacatures_45in_45_91slug_93NLehJPFQ57Meta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures-in-[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures-slug",
    path: "/vacatures/:slug()",
    meta: _91slug_93aXCCm8Su3KMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures/[slug].vue").then(m => m.default || m)
  },
  {
    name: "vacatures",
    path: "/vacatures",
    meta: indexKoAgAB8awRMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vacatures/index.vue").then(m => m.default || m)
  },
  {
    name: "vragen",
    path: "/vragen",
    meta: vragenI2Bd5lyTCdMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/vragen.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-slug",
    path: "/werkgevers/:slug(.*)*",
    meta: _91_46_46_46slug_93HBL5YJ0b5eMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-bedankt",
    path: "/werkgevers/bedankt",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/bedankt.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-faq",
    path: "/werkgevers/faq",
    meta: faqVNyXHC4VidMeta || {},
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/faq.vue").then(m => m.default || m)
  },
  {
    name: "werkgevers-registratie-inlenersbeloning",
    path: "/werkgevers/registratie-inlenersbeloning",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkgevers/registratie-inlenersbeloning.vue").then(m => m.default || m)
  },
  {
    name: "werkwijze",
    path: "/werkwijze",
    component: () => import("/data/www/westerduin.nl/westerduin/releases/20/nuxt/pages/werkwijze.vue").then(m => m.default || m)
  }
]